// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"TimeInOut_overlayWrapper__z6Orn","uploadBox":"TimeInOut_uploadBox__+Czd8","customFileUpload":"TimeInOut_customFileUpload__3uPZl"};